// import theme from "../../../theme/theme";

import color from "../../../../constants/color";

export const style = {
  root: {
    flexGrow: 1,
    // padding: 40,
  },

  paper: {
    height: "100%",
    paddingBottom: 0,
  },
  noShadow: {
    borderRadius: "30px",
    backgroundColor: color.card,
    padding: "20px",
    marginTop: "10px",
  },
  upperContainer:{
    display: {xs: "block", md: "flex"},
    flexDirection:"row",
    justifyContent: "space-between",
  },
  avatar: {
    width: "60px",
    height: "60px",
    // marginBottom: "5px",
    // margin: 'auto',
    mr: 2,
  },
  bioSection: {
    // padding: theme.spacing(2),
    textAlign: "left",
    ml: "34px"
  },
  icon: {
    marginRight: 1,
    color: color.lightText,
    fontSize: "14px"
  },
  card: {
    backgroundColor: color.card,
    mb: 3,

    p: 3,
    borderRadius: "30px"
  },
  bioText: {
    fontSize: "12px",
    fontweight: "400",
    color: color.text,
    display: "flex",
    alignItems: "center",
    mb: "10px",
  },
  infoBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    mt: 2
  },
  infooBox: {
    mt: 2,
  },

  iconText: {
    display: "flex",
    mb: "25px",
    width:"10em"
  },
  iconRight: {
    display: "flex",
    width: {xs: "52%", md:"27%"},

    justifyContent:"flex-start",
    ml:"25px"
  },
  bioIconText: {
    fontSize: "12px",
    fontWeight: "400",
    color: color.text,
    display: "flex",
    alignItems: "center",
    ml: "10px",
  },
  bioTextValue: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    display: "flex",
    alignItems: "center",
    mb: "25px",

  },


  profileBox: {
    display: "flex",
    alignItems: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    mb: "54px",
    mx: 2,
  },
  main: {
    borderRight: "1px solid lightGray",
    width: "30%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  text: {
    color: color.lightText,
  },
  textPrimary: {
    color: color.primary,
    fontSize: "14px",
    fontWeight: 500,
  },
  employeeName: {
    fontSize: "16px",
    fontWeight: "600",
  },
  employeeId: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "400",
  },

  boxHeading: {
    fontSize: "14px",
    fontWeight: "600",
    color: color.text,
  },
  gridbioBox: {
    backgroundColor: "#ffff",
    // m: 3,
    p: 3,
    //mr: { xs: 3, sm: 3, md: 3, lg: 0 },

    borderRadius: "20px",
  },
  mainBioBox: {
    display: "flex",
    alignItems: "center",
  },
  gridInfoBox: {
    backgroundColor: "#ffff",
    mb: 3,
    p: 3,
    borderRadius: "20px",
  },
  btnSection: {
    display: "flex",
    my: { xs: 2, sm: 3, md: 3, lg: 3 },
    // ml: 2 ,
  },
  successBtn: {
    color: color.primary,
    // border: "1px solid #28AA4A",
    backgroundColor: "#28AA4A33",
    borderRadius: "20px",
    px: 5,
    py: 1,
    textTransform: "none",
    mr: 2,
    fontWeight: 400,
  },
  rejectBtn: {
    color: "red",
    // border: "1px solid red",
    backgroundColor: "#E9303033",
    borderRadius: "20px",
    px: 5,
    py: 1,
    textTransform: "none"
  }

}
